module.exports = __webpack_public_path__ + "img/add-seats.2a9c7877.png";